<ng-container *ngIf="isSelect && isRootNode">
    <mat-form-field class="width100 input-space" mat-button
        [matMenuTriggerFor]="childFormControl.disabled ? null : menu" #mainMenuTrigger="matMenuTrigger"
        (click)="openMenu()" [class]="feature">
        <mat-label *ngIf="feature != 'gitActionsDropdown'">{{title}}</mat-label>
        <input matInput [placeholder]="placeholder" [formControl]="childFormControl"
            [ngClass]="{'disabled-cursor': childFormControl.disabled}" [readonly]="isGithubActions" />
        <mat-icon matSuffix>arrow_drop_down</mat-icon>
        <mat-error *ngIf="isWorkflowConfig">{{getWfErr()}}</mat-error>
    </mat-form-field>
</ng-container>
<button *ngIf="isRootNode && !isSelect" [matMenuTriggerFor]="menu" #mainMenuTrigger="matMenuTrigger"
    (click)="openMenu()">
    {{ targetMenu }}
</button>
<mat-menu #menu="matMenu">
    <app-dynamic-recursive-menu [childCntrl]="childFormControl" [data]="data" [path]="[]"
        [mainMenuTrigger]="mainMenuTrigger" (itemSelected)="itemSelected.emit($event)"></app-dynamic-recursive-menu>
</mat-menu>